import React from 'react';

export default function RangeSelectBox(props) {
  const { options, selected, onChange, questionKey } = props;
  const values = options[0].VALUE;
  let i = parseFloat(values.start);
  let end = parseFloat(values.end);
  let inc = parseFloat(values.increment);

  let selectopt = [];
  if(end < i) {
    while (i >= end) {
      selectopt.push(i);
      let num = i + inc;
      let result = upto2Decimal(num);
      i = result;
    }
  } else {
    while (i <= end) {
      selectopt.push(i);
      let num = i + inc;
      let result = upto2Decimal(num);
      i = result;
    }
  }
  
  function upto2Decimal(num) {
      return Math.ceil(num * 100) / 100;
  }
  const handleChange = (e) => {
    let optionValue = parseInt(e.target.value);
    if(questionKey === 'unweightedgpa') {
      optionValue = parseFloat(e.target.value);
    }
    let array = [optionValue];
    if(optionValue === '') {
      array = [];
    }
    onChange(questionKey, array);
  };

  return (
    <div className="col-md-6 text-left">
      <select
        className="form-input"
        value={selected[questionKey]}
        onChange={handleChange}
      >
        <option value="">-- Select --</option>
          {values.na === "1" && end < i ? (<option value="-1">NA</option>) : (null)}
          {selectopt.map((opt, idx) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
          {values.na === "1" && end > i ? (<option value="-1">NA</option>) : (null)}
      </select>
    </div>
  );
}